import { ContactInfo } from 'components/modals/ContactInfo';
import { AccessibilityCompliance } from 'components/modals/documentModals/AccessibilityCompliance';
import { BuildingPermit } from 'components/modals/documentModals/BuildingPermit';
import { BuildingPlanReview } from 'components/modals/documentModals/BuildingPlanReview';
import { BusinessLicense } from 'components/modals/documentModals/BusinessLicense';
import { DevelopmentPermit } from 'components/modals/documentModals/DevelopmentPermit';
import { ElectricalInspection } from 'components/modals/documentModals/ElectricalInspection';
import { EnvironmentalResourcePermit } from 'components/modals/documentModals/EnvironmentalResourcePermit';
import LandTitleChange from 'components/modals/documentModals/LandTitleChange';
import { LandUseRedesignation } from 'components/modals/documentModals/LandUseRedesignation';
import MechanicalPermit from 'components/modals/documentModals/MechanicalPermit';
import { MunicipalHearing } from 'components/modals/documentModals/MunicipalHearing';
import PlatModal from 'components/modals/documentModals/PlatModal';
import PlumbingPermit from 'components/modals/documentModals/PlumbingPermit';
import { useQParam } from 'hooks/useParams';
import { QUERY_PARAM, DOCUMENT_TYPE_VALUES } from 'utils/constants/QueryParameters';

export const ModalRouter = () => {
  // Legacy URL structure to handling modals
  const bpId = useQParam(QUERY_PARAM.buildingPermit);
  const bprId = useQParam(QUERY_PARAM.buildingPlanReview);
  const blId = useQParam(QUERY_PARAM.businessLicense);
  const dpId = useQParam(QUERY_PARAM.developmentPermit);
  const contactId = useQParam(QUERY_PARAM.contactInfo);
  const eiId = useQParam(QUERY_PARAM.electricalInspection);
  const ludId = useQParam(QUERY_PARAM.landUseRedesignation);
  const landTitleChange = useQParam(QUERY_PARAM.landTitleChange);
  const platId = useQParam(QUERY_PARAM.plat);
  const mechanicalPermitId = useQParam(QUERY_PARAM.mechanicalPermit);
  const municipalHearingId = useQParam(QUERY_PARAM.municipalHearing);
  const plumbingPermitId = useQParam(QUERY_PARAM.plumbingPermit);
  const acId = useQParam(QUERY_PARAM.accessibilityCompliance);
  const erpId = useQParam(QUERY_PARAM.environmentalResourcePermit);

  // New URL structure to handling modals
  const documentType = useQParam(QUERY_PARAM.documentType);

  return (
    <>
      {dpId && <DevelopmentPermit />}
      {bpId && <BuildingPermit />}
      {bprId && <BuildingPlanReview />}
      {blId && <BusinessLicense />}
      {contactId && <ContactInfo />}
      {eiId && <ElectricalInspection />}
      {ludId && <LandUseRedesignation />}
      {landTitleChange && <LandTitleChange />}
      {platId && <PlatModal />}
      {mechanicalPermitId && <MechanicalPermit />}
      {municipalHearingId && <MunicipalHearing />}
      {plumbingPermitId && <PlumbingPermit />}
      {acId && <AccessibilityCompliance />}
      {erpId && <EnvironmentalResourcePermit />}
      {documentType === DOCUMENT_TYPE_VALUES.ACCESSIBILITY_COMPLIANCE && (
        <AccessibilityCompliance enableFetchByDocumentId />
      )}
      {documentType === DOCUMENT_TYPE_VALUES.BUILDING_PERMIT && (
        <BuildingPermit enableFetchByDocumentId />
      )}
      {documentType === DOCUMENT_TYPE_VALUES.ENVIRONMENTAL_RESOURCE_PERMIT && (
        <EnvironmentalResourcePermit enableFetchByDocumentId />
      )}
      {documentType === DOCUMENT_TYPE_VALUES.BUILDING_PLAN_REVIEW && (
        <BuildingPlanReview enableFetchByDocumentId />
      )}
      {documentType === DOCUMENT_TYPE_VALUES.BUSINESS_LICENSE && (
        <BusinessLicense enableFetchByDocumentId />
      )}
      {documentType === DOCUMENT_TYPE_VALUES.DEVELOPMENT_PERMIT && (
        <DevelopmentPermit enableFetchByDocumentId />
      )}
      {documentType === DOCUMENT_TYPE_VALUES.ELECTRICAL_INSPECTION && (
        <ElectricalInspection enableFetchByDocumentId />
      )}
      {documentType === DOCUMENT_TYPE_VALUES.LAND_TITLE_CHANGE && (
        <LandTitleChange enableFetchByDocumentId />
      )}
      {documentType === DOCUMENT_TYPE_VALUES.LAND_USE_REDESIGNATION && (
        <LandUseRedesignation enableFetchByDocumentId />
      )}
      {documentType === DOCUMENT_TYPE_VALUES.MECHANICAL_PERMIT && (
        <MechanicalPermit enableFetchByDocumentId />
      )}
      {documentType === DOCUMENT_TYPE_VALUES.MUNICIPAL_HEARING && (
        <MunicipalHearing enableFetchByDocumentId />
      )}
      {documentType === DOCUMENT_TYPE_VALUES.PLAT && (
        <PlatModal enableFetchByDocumentId />
      )}
      {documentType === DOCUMENT_TYPE_VALUES.PLUMBING_PERMIT && (
        <PlumbingPermit enableFetchByDocumentId />
      )}
    </>
  );
};
